// Polyfills
import 'babel-polyfill';

// jQuery — exposed globally because Bootstrap and legacy modules expect window.$
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// Third-party
import 'jquery-ui-dist/jquery-ui';
import 'jquery.turbolinks/vendor/assets/javascripts/jquery.turbolinks';
import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
Rails.start();
Turbolinks.start();
window.Turbolinks = Turbolinks;
ReactRailsUJS.detectEvents();
import 'bootstrap-sass/assets/javascripts/bootstrap';
import 'parsleyjs';
import 'parsleyjs/dist/i18n/fr';
import 'parsleyjs/dist/i18n/es';
import 'velocity-animate';
import '../vendor/parsley-custom';
import '../vendor/parsley-credit-card';
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin(jQuery);

// React + react-rails UJS (webpacker mode)
import ReactRailsUJS from 'react_ujs';
const componentRequireContext = require.context('../react', true);
ReactRailsUJS.useContext(componentRequireContext);

// App components
import '../components';

// App init
import Main from '../main';

document.addEventListener('turbolinks:before-visit', () => {
  $.Velocity($('.page-wrapper'), 'fadeOut', { duration: 50 });
});

document.addEventListener('turbolinks:load', () => {
  window.CrunchMemberPortal = window.CrunchMemberPortal || Main();
  window.CrunchMemberPortal.init();
  window.generalAnalytics = require('../actions/generalAnalytics').default;
  window.generalAnalytics.virtualPageView();
  setTimeout(function() {
    $.Velocity($('.page-wrapper'), 'fadeIn', { duration: 50 });
  }, 100);
});

window.addEventListener('load', () => {
  window.generalAnalytics = require('../actions/generalAnalytics').default;
  window.generalAnalytics.login();
  window.addEventListener('CCM:Reservation', window.generalAnalytics.handleReservation);
});
